<template>
    <card-list-item chevron @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon>
            <i class="fa-fw" :class="[icon, {'fas': active, 'far': !active}]"></i>
        </template>
        <template v-slot:content>
            <div class="title">{{title}}</div>
        </template>
        <template v-slot:badge v-if="badge">
            <b-badge variant="primary">{{badge}}</b-badge>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "./CardListItem";
    export default {
        name: 'NavigationListItem',
        components: {CardListItem},
        props: {
            title: String,
            icon: String,
            badge: [String, Number],
            active: Boolean
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        padding: 0.6rem 0;

        .title {
            font-size: 0.95rem;
            font-weight: bold;
        }
    }
</style>
